<template>
  <div>
    <!-- <div class="row">
      <b-button variant="primary" @click="toggleType" class="mb-2 ml-1 mr-1">
        {{ type == 'tables' ? 'عرض بطاقات' : 'عرض جداول' }}
      </b-button>
      <b-dropdown id="ddown2" :text="this.quranProgram.SaveType == 'asc' ? 'تنازلي' : 'تصاعدي'" variant="primary"
        size="xs" class="mb-2">
        <b-dropdown-item @click="changeSaveType()" v-if="$role == 'super_admin' || $role == 'QuranAdmin'">
          {{ this.quranProgram.SaveType == "asc" ? "تصاعدي" : "تنازلي" }}
        </b-dropdown-item>
      </b-dropdown>
    </div> -->
    <b-dropdown id="ddown2" :text="this.quranProgram.SaveType == 'asc' ? 'تنازلي' : 'تصاعدي'" variant="primary"
        size="xs" class="mb-2">
        <b-dropdown-item @click="changeSaveType()" v-if="$role == 'super_admin' || $role == 'QuranAdmin'">
          {{ this.quranProgram.SaveType == "asc" ? "تصاعدي" : "تنازلي" }}
        </b-dropdown-item>
      </b-dropdown>
    <Cards v-if="type == 'cards'" />
    <TableComponent v-else />
  </div>

</template>

<script>
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import controller from "@/Controllers/QuranScheduleDateController";
import flatPickr from "vue-flatpickr-component";
import QuranPrograms from "@/Controllers/QuranProgramsController";


import Cards from "./components/QuranScheduleSystemic/Cards.vue";
import TableComponent from "./components/QuranScheduleSystemic/Table.vue";

const ctr = new controller();
export default {
  name: "QuranProgramsٍtudent",
  components: {
    flatPickr,
    Cards,
    TableComponent
  },
  data() {
    return {
      type: 'cards',
      tableFields: [
        { key: "alward", label: "الوِرْد" },
        { key: "partNumber", label: "الجزء" },
        { key: "alhizb", label: "الحزب" },
        { key: "quarter", label: "الربع" },
        { key: "teacher", label: "أعضاء هيئة التدريس" },
        { key: "date", label: "موعد المقرأة" },

        { key: "pass", label: "الأجتياز بنجاح" },
        { key: "actions", label: "الإجراءات" },
      ],
      items: [],
      tab: 0,
      load: true,
      sideImg: require("@/assets/images/pages/buldozer.png"),
      currentPage: 1,
      selectItem: {},
      newDate: {},
      page: 1,
      perPage: 8,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      programSelelcted: {},
      usersSelelcted: [],
      users: [],
      teacherName: "",
      last: {},
      quranProgram: {},
      last: null,
    };
  },
  methods:{
    changeSaveType() {
      this.quranProgram.SaveType =
        this.quranProgram.SaveType == "asc" ? "desc" : "asc";
      new QuranPrograms().Updata(this.quranProgram);
      
    },
  },
  async created() {
    this.quranProgram = await new QuranPrograms().Show(this.$route.params.id);
   
  },
  // async created() {
  //   // this.users = await new UsersController().GetAll({
  //   //   type: "teacher",
  //   //   filter: "quran_program_supervise|1",
  //   // });
  //   this.quranProgram = await new QuranPrograms().Show(this.$route.params.id);

  //   // هنجيب اخر ورد الطالب خلصه 
  //   // لو فيه complete هناخد الورد دة
  //   // لو مفيش هنجيب اخر ورد متسجل و ناخد القبله 
  //   if (!this.last) {
  //     const last = await ctr.GetAll({
  //       per_page: 1,
  //       page: 1,
  //       sort: "id|desc",
  //       filter: "quran_program_id|" + this.$route.params.id + "&&complete|1",
  //     });
  //     this.last = last.data[0]?.alward;
  //     if (!this.last) {
  //       const last = await ctr.GetAll({
  //         per_page: 1,
  //         page: 1,
  //         sort: "id|desc",
  //         filter: "quran_program_id|" + this.$route.params.id,
  //       });
  //       this.last = last.data[0]?.alward - 1;
  //     }
  //     // بنشوف اخر ورد ضمن انهي صفحة لو كل صفحة متقسمة 8 وردات
  //     if (this.type != 'tables') {
  //       this.currentPage = Math.ceil(this.last / 8);
  //     }
  //   }


  //   if (this.type == 'tables') {
  //     this.perPage = 240;
  //   }
  //   this.dataProvider(0);

  // },
  // methods: {
  //   toggleType() {
  //     if (this.type == 'tables') {
  //       this.type = 'cards';
  //       this.perPage = 8;
  //     } else {
  //       this.type = 'tables';
  //       this.perPage = 240;
  //     }
  //     this.currentPage = 1;



  //     setTimeout(() => {
  //       console.log("this.perPage", this.perPage);
  //       console.log("this.currentPage", this.currentPage);
  //       console.log('switch');

  //       this.dataProvider()
  //     }, 100);
  //   },


  //   async dataProvider(onstart = 0) {
  //     this.load = true;
  //     let alhizb = 1;
  //     this.items = [];
  //     /*
  //     مثلاً لو بادئ من الجزءالخامس
  //     تصاعدي هيبقي الجزء الخامس لتلاتين
  //     240 - (4 * 8) = 208
  //     30 - 5 + 1 = 26 * 8 = 208 //(30 - this.quranProgram.period + 1) * 8;
  //     تنازلي هيبقي الخامس للأول
  //     5 * 8 = 40 //this.quranProgram.period * 8;
  //     */
  //     if (this.quranProgram.SaveType == "desc") {
  //       this.totalRows = this.quranProgram.period * 8;
  //     } else {
  //       this.totalRows = (30 - this.quranProgram.period + 1) * 8;
  //     }




  //     const data = await ctr.GetAll(this.apiParamsConverter());
  //     console.log("data", data);
  //     this.currentPage = data.current_page;
  //     if (this.currentPage == 1)
  //       this.teacherName = data.data[0]?.teachers[0]?.full_name;
  //     this.perPage = data.per_page;
  //     // // this.totalRows = data.total;
  //     this.from = data.from;
  //     this.to = data.to;
  //     this.total = data.total;
  //     this.data = data.data;
  //     let countOfRows = this.type == 'tables' ? 240 - this.last : 8;
  //     for (let index = 0; index < countOfRows; index++) {
  //       let currentPage = this.currentPage;
  //       if (this.quranProgram.period > 0)
  //         if (this.quranProgram.SaveType == "desc") {
  //           currentPage = this.quranProgram.period - (this.currentPage - 1); //current_period
  //         } else {
  //           currentPage = this.currentPage + (this.quranProgram.period - 1); //current_period
  //         }
  //       let alward, partNumber, quarter;
  //       if (this.type != 'tables') {
  //         quarter = index + 1;
  //         if (index > 3) {
  //           alhizb = 2;
  //           quarter -= 4;
  //         }
  //         alward = (currentPage - 1) * 8 + (quarter + (alhizb - 1) * 4);
  //         partNumber = currentPage;
  //       } else {
  //         partNumber = Math.floor((this.last + index) / 8) + 1;
  //         alhizb = Math.floor(((this.last + index) % 8) / 4) + 1;
  //         quarter = ((this.last + index) % 4) + 1;
  //         alward = (partNumber - 1) * 8 + (quarter + (alhizb - 1) * 4);
  //       }


  //       console.log("alward", alward);
  //       const item = this.data.find((a) => {
  //         return a.alward == alward;
  //       });

  //       // console.log("item", item);

  //       this.items.push({
  //         index: index,
  //         alward: alward,
  //         partNumber: partNumber,
  //         alhizb: alhizb,
  //         quarter: quarter,
  //         item: item,
  //       });
  //     }
  //     alhizb = 2;
  //     if (onstart != 1) {
  //       if (this.type != 'tables') {
  //         //بنروح لل8 ورود الفيهم ورد الطالب
  //         setTimeout(() => {
  //           //get period of this.last + 1
  //           let period = 0;
  //           let current_ward_to_start = this.last + 1;
  //           period = Math.ceil(current_ward_to_start / 8);
  //           if (this.quranProgram.SaveType == "asc") {
  //             var current_page_to_redirect = period - this.quranProgram.period + 1;
  //           } else {
  //             var current_page_to_redirect = this.quranProgram.period - period + 1;
  //           }
  //           this.currentPage = current_page_to_redirect;

  //         }, 100);
  //       }

  //     }

  //     this.load = false;


  //     return data;
  //   },


  //   apiParamsConverter() {
  //     const apiParams = { per_page: this.perPage };
  //     if (this.currentPage >= 1) {
  //       apiParams.page = this.currentPage;
  //     }


  //     if (this.search !== "") {
  //       apiParams.search = this.search;
  //     }

  //     apiParams.with = ["teachers", "onlineSession", "students"];
  //     apiParams.filter = "quran_program_id|" + this.$route.params.id;
  //     apiParams.sort = "created_at|asc";
  //     return apiParams;
  //   },

  //   checkComplete(item) {
  //     if (item.item && item.item.complete == 1) {
  //       return false;
  //     }
  //     if (this.quranProgram.SaveType == "asc") {
  //       if (item.alward == this.last + 1) {
  //         if (item.item && item.item.onlline_class_id != 0) {
  //           return false;
  //         }
  //         return true;
  //       }
  //     } else {
  //       if (this.last % 8 == 0) {
  //         if (this.last - 15 == item.alward) {
  //           if (item.item) {
  //             return false;
  //           }
  //           return true;
  //         }
  //       } else {
  //         if (item.alward == this.last + 1) {
  //           if (item.item && item.item.complete == 1) {
  //             return false;
  //           }
  //           return true;
  //         }
  //       }
  //     }
  //     return false;
  //   },
  //   // Static
  //   changeSaveType() {
  //     this.quranProgram.SaveType =
  //       this.quranProgram.SaveType == "asc" ? "desc" : "asc";
  //     new QuranPrograms().Updata(this.quranProgram);
  //     this.dataProvider(0);
  //   },
  //   open(item, index) {
  //     this.selectItem = item;
  //     this.indexItem = index;
  //   },
  //   setSelectItem(item) {
  //     this.newDate = {};
  //     this.selectItem = item;
  //   },
  //   async save() {
  //     this.load = true;
  //     if (this.selectItem.item) {
  //       this.newDate.id = this.selectItem.item.id;
  //       this.newDate.onlline_class_id = this.selectItem.item.onlline_class_id;
  //     }
  //     this.newDate.alward = this.selectItem.alward;

  //     this.newDate.quran_program_id = this.$route.params.id;

  //     this.newDate.title =
  //       "- الجزء" +
  //       this.selectItem.partNumber +
  //       " - الحزب - " +
  //       this.selectItem.alhizb +
  //       "- الربع - " +
  //       this.selectItem.quarter;

  //     this.newDate.systemic = 1;
  //     // this.newDate.systemic = 1;
  //     await ctr.From(this.newDate, "FormData");

  //     this.dataProvider();
  //   },
  //   async complete(item) {
  //     this.load = true;
  //     await ctr.Updata(item);
  //     //add 1 to last
  //     this.last += 1;
  //     this.dataProvider();
  //   },
  //   openLive(data) {
  //     new OnlineSessionController().joinLecture(data.online_session.id);
  //   },

  //   onChangePage(page) {
  //     this.currentPage = page;
  //     this.dataProvider(1);
  //   },
  // },


};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
[dir] .demo-inline-spacing>* {
  margin-top: 0px !important;
}
</style>